import { ThirdPartyAuthService } from 'services/client-api-wrapper';
import { getApiGatewayUrl } from 'kits/urlKit';

export const thirdPartyAuthService = new ThirdPartyAuthService(getApiGatewayUrl('other', 'default'));
